class FilterList extends HTMLElement {
  constructor() {
    super();

    this.listEl = this.querySelector('.js-filter-list');
    this.listItemEls = this.listEl.querySelectorAll('li');
    this.searchInputEl = this.querySelector('.js-filter-search');
  }

  connectedCallback() {
    this._attachEventListeners();
  }

  _attachEventListeners() {
    this.searchInputEl?.addEventListener("input", this._onSearchTextInput.bind(this));
  }

  _onSearchTextInput() {
    const filterText = this.searchInputEl.value.toLowerCase();
    this.listItemEls.forEach(item => {
      const label = item.dataset.value.toLowerCase();
      item.style.display = label.includes(filterText) ? '' : 'none';
    });
  }
}

customElements.define('filter-list', FilterList);